<input
  id="image-select"
  class="hidden-input"
  type="file"
  accept="*"
  multiple
  (change)="onSelectFilesFromTarget($event.target)"
/>
<app-block-wrapper [_editable]="_editable" [style]="style">
  <app-drop (onFileDrop)="onSelectFiles($event)" [hoverStyle]="'white'" borderStyle="rounded">
    <app-dot-rectangles [shadowMode]="state.conversionCache.length > 0">
      <ng-container *ngIf="state.conversionCache.length; else uploadView">
        <div class="conversions">
          <div *ngFor="let conversion of state.conversionCache; trackBy: trackFn" class="conversion-item">
            <div
              class="conversion-icon"
              *ngIf="canRenderConversion(conversion); else imagePlaceholder"
              [style.background-image]="'url(' + conversion.result.src + ')'"
            ></div>
            <ng-template #imagePlaceholder>
              <div class="conversion-icon">
                <app-svg src="/assets/icons/document-image.svg"></app-svg>
              </div>
            </ng-template>

            <div class="conversion-file-info">
              <div class="filename">
                <ng-container *ngIf="conversion.status !== 'done'">{{ conversion.file.name }}</ng-container>
                <ng-container *ngIf="conversion.status === 'done'">{{ conversion.result.outputName }}</ng-container>
              </div>
              <div class="filesize">
                <ng-container *ngIf="conversion.status !== 'done'">{{ conversion.file.size | dataUnits }}</ng-container>
                <ng-container *ngIf="conversion.status === 'done'">{{
                  conversion.result.outputSize | dataUnits
                }}</ng-container>
              </div>
            </div>

            <div class="spacer"></div>

            <ng-container *ngIf="conversion.result; else conversionProcessing">
              <ng-container *ngIf="conversion.status === 'error'; else conversionSuccess">
                <div class="conversion-action-title">An error occurred while converting the file</div>
                <app-svg src="/assets/icons/alert.svg" color="warn" [appTooltip]="conversion.result.error"></app-svg>
              </ng-container>
              <ng-template #conversionSuccess>
                <app-svg src="/assets/icons/check.svg" size="0" color="green"></app-svg>
                <div class="conversion-action-title">
                  {{ conversion.result.timeTaken / 1000 | number : '1.0-2' }} seconds
                </div>
                <a
                  appButton
                  name="save"
                  location="convert"
                  [iconButton]="true"
                  color="simple-gray-50"
                  [download]="conversion.result.outputName"
                  [href]="conversion.result.src"
                >
                  <app-svg src="/assets/icons/download.svg"></app-svg>
                </a>
              </ng-template>
            </ng-container>

            <ng-template #conversionProcessing>
              <ng-container
                *ngIf="conversion.status === 'pending' || conversion.status === 'processing'; else conversionNotStarted"
              >
                <div class="conversion-action-title">
                  <ng-container *ngIf="conversion.status === 'pending'">Pending...</ng-container>
                  <ng-container *ngIf="conversion.status === 'processing'">Processing...</ng-container>
                </div>
                <app-loading-indicator size="32"></app-loading-indicator>
              </ng-container>
              <ng-template #conversionNotStarted>
                <div class="conversion-action-title">Convert to</div>
                <app-context-menu
                  [options]="{ width: '360px', noSpacing: true }"
                  verticalPosition="bottom"
                  class="format-selector"
                  #toFormatMenu
                >
                  <button
                    appButton
                    name="from-format"
                    location="conversion-format-switcher"
                    contextButton
                    weight="bold"
                    [hasIcon]="true"
                  >
                    <span>{{ (conversion.toFormat | uppercase) || 'Choose' }}</span>
                    <app-svg src="/assets/icons/chevron-down.svg" size="0"></app-svg>
                  </button>

                  <app-conversion-format-select-menu-content
                    contextContent
                    *ngIf="toFormatMenu.isOpen"
                    [mode]="'to'"
                    [fromFormat]="fromFormat"
                    [toFormat]="getFormat(conversion.toFormat) | async"
                    [simpleMode]="true"
                    (formatSelected)="switchConversionToFormat(conversion, $event); toFormatMenu.close()"
                  ></app-conversion-format-select-menu-content>
                </app-context-menu>
              </ng-template>
            </ng-template>
          </div>
        </div>
        <div class="all-conversions-actions">
          <label
            for="image-select"
            appButton
            name="add-more"
            location="convert"
            [hasIcon]="true"
            shape="round"
            height="3"
            heightMobile="2"
            size="3"
            sizeMobile="2"
            weight="bold"
            spacing="3"
            spacingMobile="2"
          >
            <app-svg src="/assets/icons/plus.svg"></app-svg>
            <span>Add More</span>
          </label>
          <button
            appButton
            name="reset"
            location="convert"
            [iconButton]="true"
            shape="round"
            height="3"
            heightMobile="2"
            (click)="reset()"
          >
            <app-svg src="/assets/icons/undo.svg"></app-svg>
          </button>

          <div class="spacer"></div>

          <app-context-menu [options]="{ width: '320px', noSpacing: true }" #toFormatMenu>
            <button
              appButton
              name="settings"
              location="conversion-format-switcher"
              contextButton
              weight="bold"
              height="3"
              heightMobile="2"
              shape="round"
              [iconButton]="true"
            >
              <app-svg src="/assets/icons/gear.svg"></app-svg>
            </button>

            <div contextContent class="settings-context-menu">
              <div class="settings-menu-item">
                <h3>Output Quality</h3>
                <p>Great for high-quality conversions.</p>

                <div class="quality" appTooltip="Quality" *ngIf="showConvertAllButton()">
                  <form [formGroup]="qualityForm" class="slider">
                    <input type="range" formControlName="quality" min="1" max="100" steps="1" />
                  </form>

                  <div class="quality-text">{{ qualityForm.value.quality }}</div>
                </div>
              </div>
              <div class="settings-menu-item">
                <label class="raw-acceleration">
                  <div class="raw-acceleration-content">
                    <h3>RAW Acceleration</h3>
                    <p>If available, use the embedded preview for faster conversions.</p>
                  </div>

                  <div class="switch small" appTransitionPreventor>
                    <input type="checkbox" id="show-password" [(ngModel)]="rawAccelleration" />
                    <label for="show-password"></label>
                  </div>
                </label>
              </div>
            </div>
          </app-context-menu>

          <div
            class="convert-all-container"
            [appTooltip]="canConvert() ? 'Convert Files' : 'Please choose the target format for your files.'"
          >
            <button
              appButton
              name="convert-all"
              location="convert"
              [hasIcon]="true"
              shape="round"
              height="3"
              heightMobile="2"
              size="3"
              sizeMobile="2"
              weight="bold"
              spacing="3"
              fullWidthMobile="true"
              color="primary"
              [class.disabled]="!canConvert()"
              (click)="convertAll()"
              *ngIf="showConvertAllButton(); else convertAllLoading"
            >
              <app-svg src="/assets/icons/arrow-refresh.svg"></app-svg>
              <span>Convert All</span>
            </button>
          </div>

          <ng-template #convertAllLoading>
            <app-loading-indicator *ngIf="showLoadingAllButton(); else downloadAllButton"> </app-loading-indicator>
          </ng-template>

          <ng-template #downloadAllButton>
            <button
              appButton
              name="save-all"
              location="convert"
              [hasIcon]="true"
              shape="round"
              height="3"
              heightMobile="2"
              size="3"
              sizeMobile="2"
              fullWidthMobile="true"
              weight="bold"
              spacing="3"
              color="primary"
              (click)="saveAll()"
            >
              <app-svg src="/assets/icons/download.svg"></app-svg>
              <span [class.hidden-text]="savingAll">Save All</span>
              <app-loading-indicator *ngIf="savingAll" color="white" size="small" class="button-loading-indicator">
              </app-loading-indicator>
            </button>
          </ng-template>
        </div>
      </ng-container>
      <ng-template #uploadView>
        <div class="drop-zone">
          <div class="halo"></div>
          <label for="image-select">
            <img
              [attr.data-picflow-hide]="true"
              src="/assets/icons/special/image-stack-upload-dark.svg"
              class="upload-icon"
              alt=""
            />
          </label>
          <h2 *onlyForScreens="['desktop']">Add Images</h2>
          <div class="drop-zone-text-with-button" *onlyForScreens="['desktop']">
            <span>Drag & Drop or</span
            ><label
              appButton
              name="select-assets"
              location="edit-assets-section"
              color="simple-primary-opacity"
              height="0"
              spacing="1"
              shape="small"
              for="image-select"
              >Select Images</label
            >
          </div>

          <div class="drop-assets-text-with-button" *onlyForScreens="['tablet', 'mobile']">
            <label
              appButton
              name="select-assets"
              location="edit-assets-section"
              weight="bold"
              height="1"
              shape="round"
              for="image-select"
              >Select Images</label
            >
          </div>
        </div>
      </ng-template>
    </app-dot-rectangles>
  </app-drop>
</app-block-wrapper>
